import { StyleSheet, Text, View } from 'react-native';
import React, { FC, ReactNode, useMemo } from 'react';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Footer } from '../../../components/Footer';
import { ScrollView } from 'react-native';
import PagePath from '../../../components/PagePath';
import { NavigationService } from '../../../services/navigation';
import UserWebInfo from '../../../components/UserWebInfo';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import {
  book_sports_facility_white,
  sports_coaching,
} from '../../../assets/base64';
import Coaching from './Coaching';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { MenuStackParamList } from '../../../navigation/types';
import Sidebar from '../../../components/Sidebar';

interface SportsLayoutProps {
  children?: ReactNode;
  current?: 'Facility' | 'Coaching';
  title: string;
  navigate?: NativeStackNavigationProp<MenuStackParamList, 'Sports'>;
}

const SportsLayout: FC<SportsLayoutProps> = ({
  title,
  children,
  current = 'Facility',
  navigate,
}) => {
  const pathSteps = useMemo(() => {
    return [
      {
        name: 'Member area',
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'HomeTab',
          });
        },
      },
      {
        name: 'Sports',
      },
      {
        name: title,
      },
    ];
  }, [title]);
  const SPORT_TABS = useMemo(() => {
    return [
      {
        icon: IS_WEB
          ? addBase64Prefix(book_sports_facility_white)
          : require('../../../assets/my-profile.png'),
        title: 'Facility Booking',
        tab: 'Facility',
        onPress: () => {
          if (navigate) {
            navigate.setParams({ screen: 'Facility' });
          } else {
            NavigationService.push('Root', {
              screen: 'MenuTab',
              params: {
                screen: 'Sports',
                params: {
                  screen: 'Facility',
                },
              },
            });
          }
        },
      },
      {
        icon: IS_WEB
          ? addBase64Prefix(sports_coaching)
          : require('../../../assets/book-sports-coaching.png'),
        title: 'Sports Coaching',
        tab: 'Coaching',
        onPress: () => {
          if (navigate) {
            navigate.setParams({ screen: 'Coaching' });
          } else {
            NavigationService.push('Root', {
              screen: 'MenuTab',
              params: {
                screen: 'Sports',
                params: {
                  screen: 'Coaching',
                },
              },
            });
          }
        },
      },
    ];
  }, [navigate]);
  return (
    <ScrollView>
      <View
        style={{
          maxWidth: 1250,
          width: '90%',
          marginHorizontal: 'auto',
          marginTop: 10,
        }}
      >
        <PagePath pathSteps={pathSteps} />
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginVertical: 30,
          }}
        >
          <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
            <UserWebInfo />
            <Text
              style={{
                textAlign: 'center',
                fontSize: 20,
                color: STYLE_VARS.textColor,
                marginTop: 30,
              }}
            >
              SPORTS
            </Text>
            <View
              style={{
                marginTop: 10,
                backgroundColor: STYLE_VARS.fccLightGrey,
              }}
            >
              <Sidebar
                data={SPORT_TABS}
                current={current === 'Facility' ? 0 : 1}
              />
            </View>
            <Coaching onPressCoaching={() => {}} />
          </View>
          <View style={{ width: '75%' }}>{children}</View>
        </View>
      </View>
      <Footer />
    </ScrollView>
  );
};

export default SportsLayout;

const styles = StyleSheet.create({});
